<!-- =========================================================================================
    File Name: ChatLog.vue
    Description: Chat Application - Log of chat
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<!-- hasSentPreviousMsg -->
<template>
    <div id="demfor">
        <div v-if="['SDF'].includes(artefact.type)">
            <trend-mock :artefact="artefact" type="category" :key="artefact.type+'-1'"></trend-mock>
            <grid-mock :artefact="artefact" type="category" :key="artefact.type+'-2'"></grid-mock>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import GridMock from "./GridMock.vue";
import TrendMock from "./TrendMock.vue";

import { actionsTypes } from "../shared/state";

export default {
  data() {
    return {
        payload: {
            tags:[{"tag":"Cagueuyes","code":"ccb23788-2d92-11e1-8194-0015c5e16c09","type":"S","locale":"en_US"}],
            dateRange:{"startDate":"3/21/2021","endDate":"3/29/2021"},
            query:"SDF - Cagueuyes",
            mode:"quantity",
            type:"SDF",
            res:{}
        }
    };
  },
  watch: {},
  computed: {
      ...mapGetters({artefact: "senser/artefact", isLoading: "senser/isLoading"})
  },
  methods: {
      init() {
      this.$store.dispatch('senser/'+ actionsTypes.FETCH_SENSER_ARTEFACT, this.payload);
    },
  },
  mounted() {
      this.init();
  },
  components: {
    GridMock,
    TrendMock,
  }
};
</script>

<style lang="scss">
#visualizer {
}
</style>
